module.exports = __webpack_public_path__ + "img/empty_inbox.de1fd78e.svg";